import type { IconProps } from '../types/IconProps.ts';
export const TableProperties: IconProps = {
    name: 'TableProperties',
    children: [
        `<rect width="18" height="18" x="3" y="3" rx="2" />`,
        `<path d="M3 9h18M3 15h18M15 3v18" />`,
    ]
};